/* 12-Bottle Discount Display - Wine & Spirits Only */
(function () {
  "use strict";
  var pathMatch = window.location.pathname.match(/\/products\/([^?#\/]+)/);
  if (!pathMatch) return;
  var DISCOUNT_PERCENT = 10;
  var DISCOUNT_MESSAGE = "Mix and match any wine or spirits. Save 10% when you buy 12 or more bottles.";
  var ALLOWED_TAGS = ["wine", "spirits"];
  var PRICE_SELECTORS = [".product__price .price-item--regular", ".price__regular .price-item--regular", ".product-single__price", ".product__price", ".price--regular", ".product-price", "[data-product-price]", ".price .money", ".product__info-wrapper .price"];
  function findPriceElement() {
    for (var i = 0; i < PRICE_SELECTORS.length; i++) {
      var el = document.querySelector(PRICE_SELECTORS[i]);
      if (el && el.textContent.trim().length > 0) return el;
    }
    return null;
  }
  function parsePriceCents(text) {
    var cleaned = text.replace(/[^0-9.]/g, "");
    var dollars = parseFloat(cleaned);
    return isNaN(dollars) ? null : Math.round(dollars * 100);
  }
  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }
  function createBanner(discountedPrice) {
    var wrapper = document.createElement("div");
    wrapper.className = "bottle-discount-banner";
    wrapper.style.cssText = "margin-top:8px;padding:10px 14px;border:1px dashed #b30000;border-radius:6px;background-color:#fff8f8;max-width:420px;";
    wrapper.innerHTML = '<div style="font-size:1.25em;font-weight:700;color:#b30000;margin-bottom:4px;">Buy 12+ bottles, pay ' + discountedPrice + ' each</div><div style="font-size:0.82em;color:#555;line-height:1.4;">' + DISCOUNT_MESSAGE + '</div>';
    return wrapper;
  }
  function injectBanner() {
    if (document.querySelector(".bottle-discount-banner")) return;
    var priceEl = findPriceElement();
    if (!priceEl) return;
    var priceCents = parsePriceCents(priceEl.textContent);
    if (!priceCents) return;
    var discountedCents = Math.round(priceCents * (1 - DISCOUNT_PERCENT / 100));
    var banner = createBanner(formatMoney(discountedCents));
    var insertAfter = priceEl.closest(".price") || priceEl;
    insertAfter.parentNode.insertBefore(banner, insertAfter.nextSibling);
  }
  function tryInject() {
    injectBanner();
    if (!document.querySelector(".bottle-discount-banner")) {
      setTimeout(tryInject, 1000);
    }
  }
  function startBanner() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () { setTimeout(tryInject, 500); });
    } else {
      setTimeout(tryInject, 500);
    }
    var observer = new MutationObserver(function () {
      var existing = document.querySelector(".bottle-discount-banner");
      if (existing) existing.remove();
      injectBanner();
    });
    setTimeout(function () {
      var priceEl = findPriceElement();
      if (priceEl) {
        var observed = priceEl.closest(".price") || priceEl.parentNode;
        observer.observe(observed, { childList: true, subtree: true, characterData: true });
      }
    }, 2000);
  }
  /* Fetch product JSON to check tags */
  var handle = pathMatch[1];
  var xhr = new XMLHttpRequest();
  xhr.open("GET", "/products/" + handle + ".json", true);
  xhr.onload = function () {
    if (xhr.status !== 200) return;
    try {
      var data = JSON.parse(xhr.responseText);
      var tags = (data.product && data.product.tags) ? data.product.tags.toLowerCase().split(", ") : [];
      var hasAllowedTag = false;
      for (var i = 0; i < ALLOWED_TAGS.length; i++) {
        if (tags.indexOf(ALLOWED_TAGS[i]) !== -1) { hasAllowedTag = true; break; }
      }
      if (hasAllowedTag) startBanner();
    } catch (e) { /* silently fail */ }
  };
  xhr.send();
})();